import { render, staticRenderFns } from "./AdminUserProfileDefault.vue?vue&type=template&id=f9134eb6"
import script from "./AdminUserProfileDefault.vue?vue&type=script&lang=js"
export * from "./AdminUserProfileDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports